import React from "react";
import PropTypes from "prop-types";
import submit from "submit-form";
import Modal from "../../../../parts/modal";
import ColorPicker from "../../../../parts/inputs/color-picker";

class GroupModal extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      name: "",
      color: "",
      description: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.clearFields = this.clearFields.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitUpdate = this.handleSubmitUpdate.bind(this);
  }

  componentDidMount() {
    const { originalGroupName } = this.props;
    if (originalGroupName) {
      const athletesGroupsArray = this.context.locals.activeUser.athletesGroups || [];
      const athleteGroup = athletesGroupsArray.find(
        (elem) => elem.name === originalGroupName
      );
      this.setState(athleteGroup);
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const { value, name } = target;

    this.setState({
      [name]: value,
    });
  }

  clearFields() {
    this.setState({
      name: "",
      color: "",
      description: "",
    });
  }

  handleSubmit() {
    submit(`/coaching-portal/athletes/new-group`, {
      method: "POST",
      body: this.state,
    });
  }

  handleSubmitUpdate() {
    const { originalGroupName, isAllowToViewAllOrganizationsAthletes } =
      this.props;
    const { activeUser, allAthletesFromOrganization } = this.context.locals;
    const endpoint =
      activeUser.organizationId &&
      isAllowToViewAllOrganizationsAthletes &&
      allAthletesFromOrganization &&
      allAthletesFromOrganization.length
        ? `/coaching-portal/athletes/organization-update-group`
        : `/coaching-portal/athletes/update-group`;

    submit(endpoint, {
      method: "POST",
      body: Object.assign({ originalGroupName }, this.state),
    });
  }

  render() {
    const { name, description, color } = this.state;
    const { originalGroupName } = this.props;
    return (
      <Modal className={"group-modal"}>
        <div className="head">
          <h2 className="alt">
            {originalGroupName ? "Edit" : "Create New"} Group
          </h2>
        </div>

        <div className="body">
          <form className="group-modal">
            <div className="group-text">
              <div>
                <label>
                  Name of group:
                  <input
                    name="name"
                    type="text"
                    value={name}
                    onChange={this.handleInputChange}
                    placeholder="Enter a name for your group"
                  />
                </label>
              </div>
              <div>
                <label>
                  Color of group:
                  <ColorPicker
                    textInputName="color"
                    colorInputName="color"
                    valueTextInput={color}
                    handleChangeTextInput={this.handleInputChange}
                    handleChangeColorPicker={this.handleInputChange}
                  />
                </label>
              </div>
            </div>
            <div className="group-description">
              <label>
                Description of group:
                <textarea
                  name="description"
                  type="text"
                  value={description}
                  onChange={this.handleInputChange}
                  placeholder="Enter a description for your group"
                />
              </label>
            </div>
          </form>
          <div className="group-footer">
            <a onClick={this.clearFields}>Clear all</a>
            <button
              className="button"
              onClick={
                originalGroupName ? this.handleSubmitUpdate : this.handleSubmit
              }
            >
              Save
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

GroupModal.contextTypes = { locals: PropTypes.object };

export default GroupModal;
